import {connect} from 'react-redux';
import About from './About';

const getActualState = (state) =>(
    {
        state
    }
)

const actions = (dispatch) =>(
    {
        eventsActions: (type,payload) => dispatch({type,...payload})
    }
)

export default connect(getActualState,actions)(About);